/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import CostCalculator from "./divorce/CostCalculator";
import FeesService from "./FeesService";

const calculateValueInDispute = function (divorce) {
  return {
    divorce: CostCalculator.calculateValueInDisputeDivorce(divorce),
    pensions: CostCalculator.calculateValueInDisputePensions(divorce),
    total: CostCalculator.calculateValueInDispute(divorce),
  };
};

// Calculates fees for respective value in dispute
const calculateFees = (valueInDispute) => {
  const vat = CostCalculator.getFullCosts(valueInDispute) - CostCalculator.getFullCosts(valueInDispute, false);
  return {
    lawyer: CostCalculator.getFullCosts(valueInDispute),
    lawyerNet: CostCalculator.getFullCosts(valueInDispute, false),
    court: CostCalculator.getCourtCosts(valueInDispute),
    expenses: FeesService.getExpenses(true),
    lawyerHearing: CostCalculator.getHearingCost(valueInDispute),
    lawyerCourt: CostCalculator.getProcessCost(valueInDispute),
    vat: vat,
    total: CostCalculator.getFullCosts(valueInDispute) + CostCalculator.getCourtCosts(valueInDispute),
  };
};

export { calculateValueInDispute, calculateFees };
